import { IconProps } from "../../utils/global-types/global-types";


const FbMessengerIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <g clipPath="url(#clip0_26036_232781)">
      <path
        fill="currentColor"
        d="M16.968 8.76c0 4.442-3.48 7.73-7.968 7.73a8.7 8.7 0 0 1-2.307-.306.64.64 0 0 0-.425.03l-1.582.699a.637.637 0 0 1-.894-.564l-.043-1.417a.64.64 0 0 0-.215-.454c-1.55-1.387-2.502-3.394-2.502-5.717 0-4.441 3.48-7.73 7.968-7.73 4.489 0 7.968 3.289 7.968 7.73"
      ></path>
      <path
        fill="#fff"
        d="m11.164 10.986 2.774-4.288c.279-.43-.238-.932-.66-.64L10.38 8.055a.29.29 0 0 1-.325.005l-2.57-1.663a.47.47 0 0 0-.65.139l-2.774 4.287c-.279.431.238.933.66.641L7.62 9.466a.29.29 0 0 1 .326-.004l2.57 1.662a.47.47 0 0 0 .649-.139z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_26036_232781">
        <path fill="#fff" d="M1 1h16v16H1z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default FbMessengerIcon;
